
<template>
  <div class="main">
    <el-container :style="{ height: number + 'px' }">
      <el-aside width="200px">
        <v-sidebar></v-sidebar>
      </el-aside>
      <el-container>
        <el-header>
          <v-tags></v-tags>
        </el-header>
        <el-main style="100%;">
          <div ref="borther" class="content" id="controlTest">
            <transition name="move" mode="out-in">
              <keep-alive :include="tagsList">
                <router-view></router-view>
              </keep-alive>
            </transition>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import vHead from './Header.vue';
import vSidebar from './leftNav.vue';
import vTags from './Tags.vue';
import bus from './bus';
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      fullPath: '',
      number: '',
    }
  },
  components: {
    vHead,
    vSidebar,
    vTags
  },
  created() {
    this.number = document.documentElement.clientHeight
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', msg => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    })
  }
}
</script>
<style >
.el-header {
  background-color: #fff;
  height: auto !important;
  border-bottom: 1px solid rgb(209, 206, 205);
}
.el-main {
  /* border: 1px solid red; */
  margin: 5px;
  background: #fff;
}
.el-card__body,
.el-main {
  padding: 2px;
  box-sizing: border-box;
}
</style>

